module.exports = __webpack_public_path__ + "s.no1.2399063f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/s.no1.jpg
// module id = Eo/v
// module chunks = 0